export const GETNOTIFICATION         = "[Notifications] Notifications";
export const GETNOTIFICATION_SUCCESS = "[Notifications] Notifications success";
export const GETNOTIFICATION_ERROR   = "[Notifications] Notifications error";
export const SET_NOTIFICATION        = "[Notifications] Notifications set";
export const APPEND_NOTIFICATIONS    = "[Notifications] Notifications append";

// Accepts page number parameter (defaults to 1)
export const getNotifications = (page = 1) => ({
  type: GETNOTIFICATION,
  payload: { page }
});

export const getNotificationsSuccess = (data, meta) => ({
  type: GETNOTIFICATION_SUCCESS,
  payload: data,
  meta: meta
});

export const getNotificationsError = (data) => ({
  type: GETNOTIFICATION_ERROR,
  payload: data,
});

export const setNotifications = (data, page, hasMore) => ({
  type: page === 1 ? SET_NOTIFICATION : APPEND_NOTIFICATIONS,
  payload: { list: data, page, hasMore },
})